<template>
    <div>
      <basic-container>
        <avue-crud
          :option="tableOption"
          :data="tableData"
          :table-loading="tableLoading"
          :page="page"
          ref="crud"
          @search-change="searchChange"
          @refresh-change="refreshChange(page)"
          @search-reset="searchClear"
          @selection-change="handleSelectionChange"
          @size-change="pageSizeChange"
          @current-change="pageChange"
        >
          <template
            slot-scope="scope"
            slot="menu"
          >
            <el-tag
              type="success"
              size="small"
              icon="el-icon-edit"
              v-if="scope.row.contact == 'YES'"
              plain
            >已联系</el-tag>
            <el-button
              type="danger"
              size="small"
              icon="el-icon-edit"
              v-else
              plain
              @click.stop="handleContact(scope.row,scope.index)"
            >标记已联系</el-button>
          </template>
        </avue-crud>
      </basic-container>
    </div>
  </template>
  
  <script>
  import { promotersApplyOption } from "@/const/salesCloud/promotersApplyOption";
  import {
    getPromotionList,
    markContact
  } from "@/api/salesCloud/bindPromoters";
  
  export default {
    name: "bindPromoters",
    data() {
      return {
        tableOption: promotersApplyOption, //表格设置属性
        tableData: [], //表格的数据
        tablePage: 1,
        tableLoading: false,
        loading: false,
        dialogFormVisible: false,
        form: { gender: "MALE" },
        formLabelWidth: "120px",
        classifySelects: [],
        currClassify: [],
        tabelObj: {},
        ids: "",
        page: {
          total: 0, //总页数
          currentPage: 1, //当前页数
          pageSize: 10 //每页显示多少条
        },
        grade: {
          box: false,
          check: []
        }
      };
    },
    created() {
      this.handleList();
    },
    watch: {},
    mounted() {},
    computed: {},
    props: [],
    methods: {
      handleRegister() {
        this.clean();
        this.dialogFormVisible = true;
      },
      clean() {
        this.currClassify = "";
        this.classifySelects = [];
        this.form = {};
      },
      searchClear() {
        this.currClassify = "";
      },
      choseClassifyItem() {
      },
      pageSizeChange(pageSize) {
        this.tableLoading = true;
        let params = this.$refs.crud.searchForm;
        params.page = this.page.currentPage;
        params.size = pageSize;
        params.clientType = "JOINS_ENGINEER";
        this.downloadData = params;
        getPromotionList(params).then(res => {
          let data = JSON.parse(res.data);
          this.tableData = data.rows;
          this.page = {
            total: data.total,
            currentPage: this.page.currentPage,
            pageSize: pageSize
          };
          this.tableLoading = false;
        });
      },
      pageChange(page) {
        this.tableLoading = true;
        let params = this.$refs.crud.searchForm;
        params.page = page;
        params.size = this.page.pageSize;
        params.clientType = "JOINS_ENGINEER";
        this.downloadData = params;
        getPromotionList(params).then(res => {
          let data = JSON.parse(res.data);
          this.tableData = data.rows;
          this.page = {
            total: data.total,
            currentPage: page,
            pageSize: this.page.pageSize
          };
          this.tableLoading = false;
        });
      },
      searchChange(params) {
        this.tableLoading = true;
        // let params = this.$refs.crud.searchForm
        params.page = this.page.currentPage;
        params.size = this.page.pageSize;
        params.clientType = "JOINS_ENGINEER";
  
        getPromotionList(params).then(res => {
          if (res.code != 500) {
            let data = JSON.parse(res.data);
            this.tableData = data.rows;
            this.page = {
              total: data.total,
              currentPage: params.page,
              pageSize: params.size
            };
            this.tableLoading = false;
          } else {
            this.tableLoading = false;
            this.tableData = [];
          }
        });
      },
      //eslint-disable-next-line
      refreshChange(page) {
        this.tableLoading = true;
        let params = this.$refs.crud.searchForm;
        params.page = page.currentPage;
        params.size = page.pageSize;
        params.clientType = "JOINS_ENGINEER";
        this.downloadData = params;
        getPromotionList(params).then(res => {
          let data = JSON.parse(res.data);
          this.tableData = data.rows;
          this.page = {
            total: data.total,
            currentPage: page.currentPage,
            pageSize: page.pageSize
          };
          this.tableLoading = false;
        });
      },
      /**
       * @title 打开新增窗口
       * @detail 调用crud的handleadd方法即可
       *
       **/
      handleAdd() {
        // this.clean()
        this.clean();
        this.$refs.crud.rowAdd();
      },
      handleEdit(row, index) {
        // this.clean()
        // this.clientType = this.formatClientType(row.useCustomerType)
        // this.joinsWorkServiceCategory = {id: row.serviceCategoryId}
        // this.choseWorkServiceItem();
        // this.joinsWorkServiceItem = {id: row.serviceItemId}
        // if (row.startTime != null && row.endTime != null) {
        //     let array = []
        //     array.push(row.startTime)
        //     array.push(row.endTime)
        //     row.startTime_endTime = array
        // }
        this.clean();
        this.currClassify = row.rootId == 0 ? (row.rootId = "") : row.rootId;
        this.$refs.crud.rowEdit(row, index);
      },
  
      /**
       * @title 获取数据
       * @detail 赋值为tableData表格即可
       *
       **/
      handleList() {
        this.tableLoading = true;
        let params = {
          clientType: "JOINS_ENGINEER",
          page: this.page.currentPage,
          size: this.page.pageSize
        };
        this.downloadData = params;
        getPromotionList(params).then(res => {
          let data = JSON.parse(res.data);
          this.tableData = data.rows;
          this.page = {
            total: data.total,
            currentPage: this.page.currentPage,
            pageSize: this.page.pageSize
          };
          this.tableLoading = false;
        });
      },
      /**
       * @title 当前选中的数据
       * @param val 选中的值
       *
       **/
      handleSelectionChange(val) {
        let ids = val.map(item => {
          return item.id;
        });
        this.ids = ids.join(",");
      },
      /**
       * @title 数据删除
       * @param row 为当前的数据
       * @param index 为当前更新数据的行数
       *
       **/
      handleContact(row) {
        let ids = "";
        ids = this.ids;
        if (row) {
          ids = row.id;
          this.$confirm(`您确定已联系该推广员吗？`, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
            .then(() => {
              markContact(ids)
                .then(res => {
                  if (res.code == "200") {
                    this.$message({
                      showClose: true,
                      message: "已标记成功",
                      type: "success"
                    });
                    this.handleList();
                  } else {
                    this.$message({
                      showClose: true,
                      message: res.message,
                      type: "error"
                    });
                  }
                })
                .catch(error => {
                  this.loading = false;
                  this.$message({
                    showClose: true,
                    message: error,
                    type: "error"
                  });
                });
            })
            .catch(() => {});
        } else {
          if (!ids) {
            this.$message({
              showClose: true,
              message: "未选中任何数据",
              type: "error"
            });
            return;
          }
          let length = ids.split(",").length;
          this.$confirm(
            `共选中${length}位工程师，您确定批量已联系吗？`,
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            }
          )
            .then(() => {
              markContact(ids)
                .then(res => {
                  if (res.code == "200") {
                    this.$message({
                      showClose: true,
                      message: "已联系成功",
                      type: "success"
                    });
                    this.handleList();
                  } else {
                    this.$message({
                      showClose: true,
                      message: res.message,
                      type: "error"
                    });
                  }
                })
                .catch(error => {
                  this.loading = false;
                  this.$message({
                    showClose: true,
                    message: error,
                    type: "error"
                  });
                });
            })
            .catch(() => {});
        }
      },
    }
  };
  </script>
  
      <style lang="scss">
  .table-container {
    padding: 8px 10px;
  }
  
  .demo-table-expand {
    font-size: 0;
  }
  
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
  </style>
  